export default "__VITE_ASSET__C_9_Q0p7__"